var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "astroCalendar", attrs: { id: "astroCalendar" } },
    [
      _vm._m(0),
      _vm.selectedDate
        ? _c(
            "div",
            { staticClass: "astroCalendar__main" },
            [
              _c("div", { staticClass: "astroCalendar__main__nav" }, [
                _c(
                  "div",
                  {
                    staticClass: "astroCalendar__main__nav__prev",
                    on: {
                      click: function($event) {
                        return _vm.preMonth()
                      }
                    }
                  },
                  [
                    _vm
                      .moment(this.selectedDate)
                      .isBefore(_vm.moment("2025-02-01"), "month")
                      ? _c("img", {
                          attrs: { src: require("@/assets/共時曆/pre.svg") }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("@/assets/共時曆/pre_active.svg")
                          }
                        })
                  ]
                ),
                _c("div", { staticClass: "astroCalendar__main__nav__date" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.calendarMonthTitle) + "\n      "
                  )
                ]),
                _c(
                  "div",
                  {
                    staticClass: "astroCalendar__main__nav__next",
                    on: {
                      click: function($event) {
                        return _vm.nextMonth()
                      }
                    }
                  },
                  [
                    _vm
                      .moment(this.selectedDate)
                      .isAfter(_vm.moment("2026-11-01"), "month")
                      ? _c("img", {
                          attrs: { src: require("@/assets/共時曆/next.svg") }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("@/assets/共時曆/next_active.svg")
                          }
                        })
                  ]
                )
              ]),
              _c("Tab", {
                staticClass: "astroCalendar__main__tab",
                attrs: { tabList: _vm.tabList, current: _vm.showType },
                on: { setActiveTab: _vm.changeTabHandler }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showType === "calendar",
                      expression: "showType === 'calendar'"
                    }
                  ],
                  staticClass: "astroCalendar__main__calendar"
                },
                [
                  _c("div", {
                    class: { calendarIsCollapsed: _vm.isCollapsed },
                    attrs: { id: "calendar" }
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isCollapsed,
                          expression: "!isCollapsed"
                        }
                      ],
                      staticClass: "astroCalendar__main__calendar__tips"
                    },
                    [
                      _vm._v("\n        *℞：代表逆行 "),
                      _c("span", { staticClass: "ml-6" }, [
                        _vm._v("→：代表进入")
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "astroCalendar__main__calendar__toggle",
                      on: { click: _vm.toggleCalendarCollapse }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "astroCalendar__main__calendar__toggle__text"
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.isCollapsed ? "點擊展開" : "點擊收合"
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "astroCalendar__main__calendar__toggle__img",
                          class: { calendarIsCollapsed: _vm.isCollapsed }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/共時曆/共時歷收合.svg"),
                              alt: ""
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _c("div", {
                    staticClass: "astroCalendar__main__calendar__divider"
                  }),
                  _c("div", { staticClass: "astroCalendarDetail" }, [
                    _c("div", { staticClass: "astroCalendarDetail__picArea" }, [
                      _c("img", { attrs: { src: _vm.topicImg, alt: "" } })
                    ]),
                    _c("div", { staticClass: "astroCalendarDetail__date" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.moment(_vm.selectedDate).format("MM/DD")) +
                          "\n          "
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.moment(_vm.selectedDate).format("ddd"))
                        )
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "astroCalendarDetail__highlight" },
                      [
                        _vm._v(
                          "\n          ★ " +
                            _vm._s(_vm.interpretation.Highlight) +
                            "\n        "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "astroCalendarDetail__themes" },
                      _vm._l(_vm.interpretation.Themes, function(theme, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "astroCalendarDetail__themes__item"
                          },
                          [
                            _vm._v(
                              "\n            " + _vm._s(theme) + "\n          "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _c("div", { staticClass: "astroCalendarDetail__teacher" }, [
                      _vm._m(1),
                      _c("div", {
                        staticClass: "teacher__content",
                        domProps: {
                          innerHTML: _vm._s(_vm.interpretation.Remind)
                        }
                      })
                    ]),
                    _c(
                      "div",
                      { staticClass: "astroCalendarDetail__interpretation" },
                      [
                        _vm._m(2),
                        _c("div", {
                          staticClass: "interpretation__content",
                          domProps: {
                            innerHTML: _vm._s(_vm.interpretation.Interpretation)
                          }
                        })
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "astroCalendarDetail__events" },
                      _vm._l(_vm.calendarDailyList, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "astroCalendarDetail__events__item",
                            on: {
                              click: function($event) {
                                return _vm.showCalendarAstrolabePopup(item)
                              }
                            }
                          },
                          [
                            _c("div", {
                              staticClass:
                                "astroCalendarDetail__events__item__dot",
                              class: {
                                isMoonDied:
                                  _vm.TYPE_MAP[item.Type] === "月空亡",
                                isRetrograde:
                                  _vm.TYPE_MAP[item.Type] === "逆行",
                                isEnterSign:
                                  _vm.TYPE_MAP[item.Type] === "進入星座"
                              }
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "astroCalendarDetail__events__item__time"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.moment(item.StartedAt).format("HH:mm")
                                    ) +
                                    "\n            "
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "astroCalendarDetail__events__item__title"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.Title) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    !_vm.theDayNote
                      ? _c(
                          "div",
                          { staticClass: "astroCalendarDetail__goToNote" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "astroCalendarDetail__goToNote__btn",
                                on: { click: _vm.addAstroCalendarNoteHandler }
                              },
                              [
                                _vm._v(
                                  "\n            写下今日的笔记吧\n          "
                                )
                              ]
                            )
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "astroCalendarDetail__theDayNote" },
                          [
                            _c("AstroCalendarNoteCard", {
                              attrs: {
                                note: _vm.theDayNote,
                                nowloginPlatform: _vm.nowloginPlatform
                              },
                              on: {
                                edit: _vm.editMoonNoteHandler,
                                delete: _vm.deleteMoonNoteHandler,
                                detail: _vm.toDetail
                              }
                            })
                          ],
                          1
                        )
                  ])
                ]
              ),
              _vm.showType === "parm"
                ? _c("AstroCalendarParm", {
                    attrs: {
                      filterOptionList: _vm.filterOptionList,
                      currentMonthEventsAll: _vm.currentMonthEventsAll
                    }
                  })
                : _vm._e(),
              _vm.showType === "note"
                ? _c(
                    "div",
                    { staticClass: "astroCalendar__main__note" },
                    [
                      _vm.noteReady && _vm.selectedDate
                        ? _c("AstroCalendarNoteList", {
                            attrs: { selectedDate: _vm.selectedDate }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.calendarAstrolabeObj
        ? _c("CalendarAstrolabePopup", {
            attrs: { calendarAstrolabeObj: _vm.calendarAstrolabeObj },
            on: {
              close: function($event) {
                _vm.calendarAstrolabeObj = null
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "astroCalendar__header" }, [
      _c("h2", { staticClass: "st_title" }, [_vm._v("共时历")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "teacher__header" }, [
      _c("div", { staticClass: "teacher__header__pic" }, [
        _c("img", {
          attrs: { src: require("../../../cn-demo-assets//Logo.png"), alt: "" }
        })
      ]),
      _c("div", { staticClass: "teacher__header__title" }, [
        _vm._v("星学会的一句叮咛")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "interpretation__header" }, [
      _c("div", { staticClass: "interpretation__header__pic" }, [
        _c("img", {
          attrs: { src: require("@/assets/共時曆/共時曆解讀星.svg"), alt: "" }
        })
      ]),
      _c("div", { staticClass: "interpretation__header__title" }, [
        _vm._v("星学会解读")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }